:host {
  min-width: min(100vw, 302px);

  .cross {
    display: none;
    color: var(--svg-primary-fill);
    cursor: pointer;
    @media screen and (max-width: 767px) {
      position: absolute;
      right: 0;
      margin: 24px;
      display: block;
    }
  }

  .hide {
    display: none !important;
  }

  .skeleton {
    padding: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    & * {
      @include skeletonRipple;
    }

    &--avatar {
      height: 42px;
      width: 42px;
      border-radius: 90px;
      margin-bottom: 16px;
    }

    &--username {
      height: 18px;
      width: 100px;
      margin-bottom: 10px;
    }

    &--mail {
      height: 16px;
      width: 140px;
      margin-bottom: 18px;
    }

    &--link {
      height: 18px;
      width: 110px;
      margin-bottom: 18px;
    }

    &--button {
      width: 254px;
      height: 45px;
    }
  }

  .layout {
    padding: 24px;
    border-radius: 10px;

    .profile {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      line-height: normal;

      &__avatar {
        margin-bottom: 16px;
      }

      &__name {
        margin-bottom: 8px;
        width: 254px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: center;
        font-size: 16px;
        font-weight: 500;
        color: #333333;
        color: var(--font-primary);
      }

      &__mail {
        margin-bottom: 16px;
        font-size: 14px;
        font-weight: 400;
        color: #666;
        color: var(--font-secondary);
      }

      &__profile-link {
        margin-bottom: 16px;
        font-size: 14px;
        font-weight: 400;
        color: #0098ff;
        color: var(--blue-link);
        text-decoration: none;
      }

      &__logout-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        width: 100%;
        padding: 14px;
        border: 0;
        border-radius: 4px;
        cursor: pointer;
        font-size: 14px;
        font-weight: 400;
        background-color: #f1f1f1;
        background-color: var(--bg-secondary-hover);
        color: #666;
        color: var(--font-secondary);

        &:hover {
          color: #0098ff;
          color: var(--blue-link);
          img {
            filter: var(--icon-blue-link);
          }
        }
      }
    }

    .user-disconnected {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      line-height: normal;

      &__icon {
        padding: 15px;
        background-color: #f5f5f5;
        background-color: var(--bg-secondary);
        border-radius: 50%;
        width: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 16px;

        img {
          width: 30px;
          height: 30px;
          object-fit: contain;
          filter: invert(35%) sepia(17%) saturate(7491%) hue-rotate(344deg) brightness(103%)
            contrast(97%);
          filter: var(--icon-orange);
        }
      }

      &__title {
        color: #333333;
        color: var(--font-primary);
        font-size: 16px;
        font-weight: 500;
        text-align: center;
        margin-bottom: 8px;
      }

      &__description {
        color: #666666;
        color: var(--font-secondary);
        font-size: 12px;
        text-align: center;
        margin-bottom: 16px;
      }

      a {
        text-decoration: none;
        width: 100%;

        button {
          width: 100%;
          background-color: #0098ff;
          background-color: var(--blue);
          color: white;
          padding: 14px;
          border: none;
          border-radius: 4px;
          cursor: pointer;

          &:hover {
            background-color: #007ee2;
            background-color: var(--blue-hover);
            transition: all 0.3s;
          }

          &:focus {
            outline: none;
          }
        }
      }
    }
  }

  .switch-group-trigger {
    background: #f5f5f5;
    background: var(--bg-secondary);
    color: #333333;
    color: var(--font-primary);
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 10px;
    margin-top: 20px;
    border-radius: 30px 30px 30px 30px;
    height: 55px;
    cursor: pointer;

    .group-info {
      display: flex;
      align-items: center;

      &__text {
        display: flex;
        flex-direction: column;
      }
    }

    .group-avatar {
      margin-right: 10px;
    }

    .group-logo {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      background-color: #fff;
      background-color: var(--bg-primary);
      width: 30px;
      min-width: 30px;
      height: 30px;
      overflow: hidden;
      margin-right: 15px;

      img {
        max-width: 20px;
      }

      .no-image-group {
        filter: invert(40%) sepia(0%) saturate(2698%) hue-rotate(349deg) brightness(94%)
          contrast(77%);
      }
    }

    .group-name {
      font-size: 14px;
      line-height: 18px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 300px;
    }

    .group-legal-entity {
      color: #666666;
      color: var(--font-secondary);
      font-size: 11px;
      letter-spacing: 0;
      line-height: 13px;
    }

    .icon {
      max-width: 12px;
      filter: invert(40%) sepia(0%) saturate(2698%) hue-rotate(349deg) brightness(94%) contrast(77%);
      filter: var(--icon-color);
    }
  }

  .switch-group-container {
    background-color: #f5f5f5;
    background-color: var(--bg-secondary);
    border-radius: 30px 30px 30px 30px;
    margin-left: 10px;
    margin-right: 10px;
    margin-bottom: 20px;
    user-select: none;
  }

  .rotate-90 {
    transform: rotate(90deg);
    transition: all 0.3s;
  }
}
